import { lazy } from "react";
/**
 * Support Module
 * Módulo de soporte técnico para debugging y monitoreo.
 * Solo accesible para usuarios con códigos en REACT_APP_SUPPORT_EMPLOYEES.
 */
const SupportPage = lazy(() => import("./pages/SupportPage"));
export const supportRoutes = [
  { path: "/support", element: <SupportPage /> },
];

export default SupportPage;
